import React from 'react';
import type { DraggableAttributes, DraggableSyntheticListeners } from '@dnd-kit/core';
import { cn } from '@/lib/utils';

interface SortableDragHandleProps {
  attributes: DraggableAttributes;
  listeners: DraggableSyntheticListeners;
  children: React.ReactNode;
  className?: string;
  ariaLabel?: string;
}

export const SortableDragHandle: React.FC<SortableDragHandleProps> = ({
  attributes,
  listeners,
  children,
  className,
  ariaLabel,
}) => {
  return (
    <div
      {...attributes}
      {...listeners}
      aria-label={ariaLabel}
      className={cn(
        'touch-none select-none p-2 -m-2 text-muted-foreground hover:text-foreground cursor-grab active:cursor-grabbing',
        className
      )}
      style={{ touchAction: 'none' }}
      onClick={(e) => e.stopPropagation()}
    >
      {children}
    </div>
  );
};
